import { render, staticRenderFns } from "./CardCheck.vue?vue&type=template&id=4a38bf11&scoped=true"
import script from "./CardCheck.vue?vue&type=script&lang=js"
export * from "./CardCheck.vue?vue&type=script&lang=js"
import style0 from "./CardCheck.vue?vue&type=style&index=0&id=4a38bf11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a38bf11",
  null
  
)

export default component.exports